import React from 'react';
export function SolutionSection() {
  return <section id="solution-section" className="py-16 overflow-hidden" style={{
    backgroundColor: '#F8F6F1'
  }} data-id="element-939">
      <div className="container mx-auto px-4 max-w-2xl" data-id="element-940">
        {/* Video Section */}
        <div className="relative rounded-[2rem] p-8 md:p-10 border-2 shadow-lg" style={{
        background: 'linear-gradient(135deg, #FFF3E0, #F8F6F1)',
        borderColor: '#6DAA7F'
      }} data-id="element-941">
          <h3 className="text-xl md:text-2xl font-bold mb-6 text-center" style={{
          color: '#2F5D50'
        }} data-id="element-942">
            Ella lo comprobó con su perro
          </h3>
          <div className="rounded-xl overflow-hidden shadow-xl border-2" style={{
          borderColor: '#6DAA7F'
        }} data-id="element-943">
            <video controls preload="auto" playsInline className="w-full h-auto" style={{
            maxHeight: '600px'
          }} data-id="element-944">
              <source src="https://ydgkmdmvhrniztrhtrxq.supabase.co/storage/v1/object/sign/audio%20receta/freepik_1080x1920_30fps_14228.mp4?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV80NDNkYTY1ZS1iYWM1LTQyYWQtODMzNS1iNWE4N2M0NDYxNmQiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJhdWRpbyByZWNldGEvZnJlZXBpa18xMDgweDE5MjBfMzBmcHNfMTQyMjgubXA0IiwiaWF0IjoxNzcxNzY2MDY4LCJleHAiOjE4MDMzMDIwNjh9.jJthctnqJad8IknGrrF_q9s4zxF0FqSFHDuaUtaZTD8#t=0.1" type="video/mp4" data-id="element-945" />
              Tu navegador no soporta el elemento de video.
            </video>
          </div>
        </div>
      </div>
    </section>;
}